<template>
  <div id="route-two-dir">
    <h4>{{ stopName }}</h4>

    <!-- utility row -->
    <div class="row">
    </div>

    <div class="row">
      <stop-route-list :routes="stopDetails.routes" />
    </div>

  </div>
</template>

<script>
import etaParse from "../../utils/etaParse";
import InlineEta from '../Eta/InlineEta';
import {mapActions, mapState} from 'vuex';
import StopRouteList from "@/components/StopInfo/StopRoutesList";

export default {
  name: "RouteInfoStop",
  components: {StopRouteList, InlineEta},
  computed: {
    ...mapState('routeInfo', ['stopDetails']),
    stopName() {
      if (!this.stopDetails.stop) {
        return '';
      }

      return this.stopDetails.stop.stopc;
    },
  },
  methods: {
    ...mapActions('routeInfo', ['getStopDetails']),
    // todo: extract this also to <inlineEta />
    stopEta(company, eta) {
      if (eta) {
        return etaParse(company, eta);
      }

      return [];
    },
  },
  mounted() {
    this.getStopDetails(this.$route.params.id);
  }

}
</script>

<style scoped>
</style>
